import {CARDS_FETCHED, CARDS_FETCHING, YTHELPER_CARDS_FETCHED, YTHELPER_CARDS_FETCHING} from "../actions/types";
import * as _ from 'lodash';
import { errorToast } from "../api/Util";

/**
 * If the same card_id appears in a primary column and in repurpose* (e.g. after
 * /api/card/{id}/timeline when repurpose_status is still set server-side), the
 * board would show duplicates. Prefer primary columns and drop repurpose copies.
 */
function sanitizeKanbanCardPayload(raw) {
    if (!raw || typeof raw !== 'object') {
        return raw;
    }
    const data = { ...raw };
    const mainKeys = ['video_requests', 'editing', 'qa_cards', 'done_cards', 'on_hold', 'cancelled_cards'];
    const mainIds = new Set();
    mainKeys.forEach((key) => {
        const arr = data[key];
        if (!Array.isArray(arr)) {
            return;
        }
        arr.forEach((c) => {
            if (c && c.card_id != null) {
                mainIds.add(Number(c.card_id));
            }
        });
    });
    const stripIfInMain = (arr) => {
        if (!Array.isArray(arr)) {
            return arr;
        }
        return arr.filter((c) => {
            if (!c || c.card_id == null) {
                return false;
            }
            return !mainIds.has(Number(c.card_id));
        });
    };
    const uniqByCardId = (arr) => (Array.isArray(arr) ? _.uniqBy(arr, (c) => Number(c?.card_id)) : arr);
    data.repurposeEditing = uniqByCardId(stripIfInMain(data.repurposeEditing));
    data.repurposeQA = uniqByCardId(stripIfInMain(data.repurposeQA));
    data.repurposeDone = uniqByCardId(stripIfInMain(data.repurposeDone));

    // repurpose_status values: 'editing' → repurposeEditing, 'repurposeQA' → repurposeQA, 'done' → repurposeDone
    const repurposeStatusToColumn = { editing: 'repurposeEditing', repurposeQA: 'repurposeQA', done: 'repurposeDone' };
    const repurposeCols = ['repurposeEditing', 'repurposeQA', 'repurposeDone'];
    const seenInRepurpose = {};
    repurposeCols.forEach((col) => {
        (data[col] || []).forEach((c) => {
            const id = Number(c?.card_id);
            if (id == null) return;
            if (!seenInRepurpose[id]) seenInRepurpose[id] = [];
            seenInRepurpose[id].push(col);
        });
    });
    Object.entries(seenInRepurpose).forEach(([idStr, cols]) => {
        if (cols.length <= 1) return;
        const id = Number(idStr);
        // Find the card object to read its repurpose_status
        let cardObj = null;
        cols.forEach((col) => {
            if (!cardObj) cardObj = (data[col] || []).find((c) => Number(c?.card_id) === id);
        });
        const correctCol = repurposeStatusToColumn[cardObj?.repurpose_status];
        cols.forEach((col) => {
            if (col !== correctCol) {
                data[col] = (data[col] || []).filter((c) => Number(c?.card_id) !== id);
            }
        });
    });

    return data;
}

export default function (state = {}, {payload, type}) {
    switch (type) {
        case CARDS_FETCHING:
            return { ...state, loading: true }
        case CARDS_FETCHED:
            if(payload.status >= 200 && payload.status < 300) {
                let cardMap = {};
                const cardList = sanitizeKanbanCardPayload(payload.data);

                 _.flatten([cardList?.video_requests, cardList?.editing, cardList?.qa_cards,
                     cardList?.done_cards, cardList?.on_hold, cardList?.cancelled_cards, cardList?.repurposeDone, cardList?.repurposeEditing, cardList?.repurposeQA, cardList?.updatedDone])
                    .forEach(card => {
                        cardMap[card?.card_id] = card;
                    });
                
                let tempObj = {};
                
                if(cardList?.monthlyCardCount || cardList?.monthlyCardCount === 0) {
                    tempObj.monthlyCardCount = cardList?.monthlyCardCount;
                }

                return {...state, cardList: cardList, cardMap: cardMap, loading: false, ...tempObj};
            }
            return {...state, loading: false};
        // for loading state
        case YTHELPER_CARDS_FETCHING:
            return {...state,loading: true}
        
        // to get all the cards and pass it to props
        case YTHELPER_CARDS_FETCHED:
            if(payload && payload.status >=200 && payload.status < 300 )
            {
                if(payload && payload?.data?.message)
                {
                    errorToast(payload?.data?.message || "No cards found try again later" );
                    return {...state, loading: false};
                }
                let cardMap = {};

                 _.flatten([payload.data?.assigne_card, payload.data?.inProgress, payload.data?.inDone])
                    .forEach(card => {
                        cardMap[card.card_id] = card;
                    });

                return {...state, ytHelperCardList: payload.data, cardMap: cardMap, loading: false};
            }
            return {...state, loading: false};
        default:
            return state;
    }
}